export namespace FlexApiUri {
  const BASE_URL = '/lcm/flex/api/v1';

  export const VALIDATE_API_TOKEN_URL = `${BASE_URL}/validate`;

  export const SAAS_ENDPOINT_INTEGRATION = `${BASE_URL}/register`;
}
